<form
  autocomplete="off"
  [formGroup]="customHostnameForm"
  (ngSubmit)="onSubmit()">
  <div class="bn-dialog modal-md mx-auto">
    <div class="bn-dialog__icon bn-dialog__icon--align-left bn-dialog__icon--warning">
      <fa-icon icon="gear" />
    </div>
    <div class="bn-dialog__title">Add a custom hostname</div>
    <div class="bn-dialog__body">
      <p>You can use a custom hostname instead of our default bunny.run hostname to present your Magic Containers app in a more branded and seamless way.</p>
      <div class="bn-dialog__title">Custom hostname</div>
      <bn-web-ui-input
        #hostnameInput
        data-e2e="HostnamesFormInput"
        formControlName="Hostname"
        inputName="Hostname"
        placeholder="api.yourapp.run"
        [options]="{ rightAddons: [{ icon: 'copy', action: 'copyToClipboard', tooltip: 'Copy to clipboard' }] }" />
    </div>
    <div class="bn-dialog__actions">
      <button
        bn-web-ui-button
        size="lg"
        type="submit"
        [loading]="isLoadingAddHostname()">
        Add Hostname
      </button>
      <button
        bn-web-ui-button
        class="ms-2"
        itemStyle="stroke"
        size="lg"
        type="button"
        (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
  </div>
</form>
